export default {
  hashCode(s) {
    let hash = 0
    let char
    if (s.length === 0) {
      return hash
    }
    for (let i = 0; i < s.length; i += 1) {
      char = s.charCodeAt(i)
      hash = ((hash << 5) - hash) + char
      hash |= 0 // Convert to 32bit integer
    }
    return hash
  },

  /**
   * calculate hash, return int value from 0 to mod
   * @param {*} str
   */
  hashMod(str, mod) {
    return Math.abs(this.hashCode(str)) % mod;
  },

  validateEmail(email) {
    const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  },

  removeUrl(code) {
    const regex = /^.*\//
    if (code && code.includes('/')) {
      const pureCode = code.split(regex)
      return pureCode[1]
    }
    return code
  },

  /**
   * Remove the urn:kz:<number> of the code if 3 or more ":" is present
   * Checking for more than 1 to handle url
   * @param {*} code
   */
  removeQualifier(code) {
    if (!code) return
    const separatorOccurences = code.split(':')
    if (code.includes(':') && (separatorOccurences.length - 1) >= 3) {
      const pureCode = code.substring(code.lastIndexOf(':') + 1, code.length)
      return pureCode
    }
    return code
  },

  sanitizeCode(code, stripQualifier) {
    if (!code) return
    const noUrlCode = this.removeUrl(code)
    const cleanCode = stripQualifier ? this.removeQualifier(code) : noUrlCode
    return cleanCode
  },

  sanitizeCodes(codes, stripQualifier) {
    if (!codes) return
    const BY_NEWLINE_OR_COMMA = /[\n\r\s,]+/
    const codesArray = codes.trim().split(BY_NEWLINE_OR_COMMA)
    const cleanCodes = codesArray.map((code) => this.sanitizeCode(code, stripQualifier))
    return cleanCodes
  },

  timezone() {
    const dstOffset = new Date().toString().substr(28, 5)
    try {
      return `${Intl.DateTimeFormat().resolvedOptions().timeZone}  ${dstOffset}`
    } catch (e) {
      return dstOffset
    }
  },

  createUniqueXRequestId() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
  },

  randomText(length) {
    let text = ''
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
  },

  initiateBlobDownload(downloadReq) {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.style = 'display: none'

    const blob = new Blob([downloadReq.data], { type: downloadReq.type })
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = downloadReq.filename

    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  }
}



// WEBPACK FOOTER //
// ./src/service/Util.js